<template>
  <div class="d-flex align-center justify-space-between" style="height: 50px">
    <div class="d-flex align-center">
      <div class="d-flex" style="width: 200px">
        <div style="width: 120px">{{ kind === 'cen' ? 'Học phí:' : 'Chuyên đề:' }}</div>
        <div>
          {{ item[kind].totalAmount.toLocaleString('en-US') }}
        </div>
      </div>
    </div>
    <ActionPeriod :kind="kind" :isPaid="item[kind].isPaid" :viewIsPaid="viewIsPaid" :report="item" />
  </div>
</template>

<script>
import ActionPeriod from '@/modules/tuitionFee/detail-period/action/ActionPeriod.vue'
export default {
  components: {
    ActionPeriod
  },
  props: {
    kind: String,
    item: Object,
    viewIsPaid: Boolean
  },
  methods: {}
}
</script>

<style></style>
